import url from '../../../../url.js';
export default {
    name: 'ClientView',
    data() {
        return {
            title: 'SDGS',
            dataSdgs: [],
            Api: url.API_URL,
            gambarUrl: url.IMAGE + 'sdgs/',
            titleSdgs: 'SDGS'
        }
    },
    methods: {
        async fetchDataClient() {
            const response = await fetch(this.Api + 'm148_sdgs/id/2');
            const data = await response.json();
            this.dataSdgs = data;
            console.log(this.dataSdgs);
        }
    },
    mounted() {
        this.fetchDataClient()
    }
}